<!-- <div class="pdfContain" style="margin: 0 auto; width: 15cm; border:1px solid #e9e9e9;position: fixed; left: -1000px; top: 0;">  -->
<div class="pdfContain" style="margin: 0 auto; width: 15cm; border:1px solid #e9e9e9;position: fixed; left: -3000px; top: 0;">
  <kendo-pdf-export #pdf margin="1cm" paperSize="A4">
    <div class="pdf-heading col-12" #headerDetails>
      <img class="app-logo" [src]="logoSrc" alt="App logo">
      <h1 class="section-title">{{ 'EVALUATION.SUMMARISED_REPORT_OK' | translate }}</h1>
    </div>
    <div class="col-12 pr-4">
      <div class="row">

        <!---- SOP ---->
        <div class="mt-2 col-12 p-0" #processComplianceDetails [ngClass]="!isSOP ? 'hideSOP' : ''" *ngIf="!processComplianceNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{ 'DASHBOARD.PROCESS_COMPLIANCE' | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="processComplianceFilter">
                    <!-- <li>{{processComplianceSopTittle | translate}}</li> -->
                    <span>{{ processComplianceFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ processComplianceFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #processComplianceChart [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountProcess">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListProcess *ngIf="childChart.categories.length > 0" [type]="'bar'"
                  [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>


              <div class="col-sm-12 col-lg-12 table-responsive mt-4">
                <div class="row mb-4" style="display:block">
                  <table *ngIf="maxFilters > 0" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>{{ 'DASHBOARD.PROCESS' | translate }}</th>
                        <th class="text-center">{{ 'DASHBOARD.PROCESS_COMPLIANCE' | translate }}%</th>
                        <ng-container
                          *ngFor="let filter of [].constructor(maxFilters > 3 ? 3 : maxFilters) let f = index">
                          <th class="text-center">{{ 'EVALUATION.FILTER_' + (f + 1) + '.AMOUNT_COMPLIANT_OBSERVATIONS' |
                            translate
                            }}</th>
                          <th class="text-center">{{ 'EVALUATION.FILTER_' + (f + 1) + '.TOTAL_AMOUNT_OBSERVATIONS' |
                            translate
                            }}
                          </th>
                        </ng-container>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let grid of gridData">
                        <td>{{grid.title | translate | labelSanitizer}}</td>
                        <td class="text-center">{{grid.processCompliancePercentage}}%</td>
                        <ng-container
                          *ngFor="let filter of [].constructor(maxFilters > 3 ? 3 : maxFilters) let f = index">
                          <td class="text-center">{{grid['totalCompliantObservationsforfilter' + (f + 1)]}}</td>
                          <td class="text-center">{{grid['totalObservationsforfilter' + (f + 1)]}}</td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <table *ngIf="maxFilters > 3" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>{{ 'DASHBOARD.PROCESS' | translate }}</th>
                        <th class="text-center">{{ 'DASHBOARD.PROCESS_COMPLIANCE' | translate }}%</th>
                        <ng-container *ngFor="let filter of [].constructor(maxFilters - 3) let f = index">
                          <th class="text-center">{{ 'EVALUATION.FILTER_' + (f + 4) + '.AMOUNT_COMPLIANT_OBSERVATIONS' |
                            translate
                            }}</th>
                          <th class="text-center">{{ 'EVALUATION.FILTER_' + (f + 4) + '.TOTAL_AMOUNT_OBSERVATIONS' |
                            translate
                            }}
                          </th>
                        </ng-container>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let grid of gridData">
                        <td>{{grid.title | translate | labelSanitizer}}</td>
                        <td class="text-center">{{grid.processCompliancePercentage}}%</td>
                        <ng-container *ngFor="let filter of [].constructor(maxFilters - 3) let f = index">
                          <td class="text-center">{{grid['totalCompliantObservationsforfilter' + (f + 4)]}}</td>
                          <td class="text-center">{{grid['totalObservationsforfilter' + (f + 4)]}}</td>
                        </ng-container>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 col-12 p-0" #frequencyDistributionDetails [ngClass]="!isSOP ? 'hideSOP' : ''" *ngIf="!frequencyDistributionNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{ 'EVALUATION.FREQUENCY_DISTRIBUTION.DISPLAY_TEXT' | translate }}
                  </h1>
                  <div class="staticCardUlList" *ngIf="frequencyDistributionFilter">
                    <span>{{frequencySopTittle | translate | labelSanitizer}}</span>
                    <span>{{ frequencyDistributionFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ frequencyDistributionFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #frequencyChart [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountFrequency">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListFrequency *ngIf="childChart.categories.length > 0" [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 col-12 p-0" #subStepComplianceDetails [ngClass]="!isSOP ? 'hideSOP' : ''" *ngIf="!subProcessNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{ 'EVALUATION.SUB_STEP_COMPLIANCE' | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="subStepProcessComplianceFilter">
                    <span>{{subStepProcessComplianceSopTittle | translate | labelSanitizer}}</span>
                    <!-- <li>{{ 'EVALUATION.All.STEPS' | translate }}</li> -->
                    <span>{{ subStepProcessComplianceFilter.filter[0].startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ subStepProcessComplianceFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #subStepProcessChart [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountSubstep">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListSubstep *ngIf="childChart.categories.length > 0" [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 col-12 p-0" #commentsDetails [ngClass]="!isSOP ? 'hideSOP' : ''" *ngIf="!sopCommentsNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{ 'EVALUATION.SOP_COMMENTS' | translate }} {{ 'SOP_MANAGEMENT.COMMENTS' | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="predefinedCommentsFilter">
                    <!-- <li>{{predefinedCommentsSopTittle | translate}}</li> -->
                    <span>{{ predefinedCommentsFilter?.filter?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ predefinedCommentsFilter?.filter?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">

              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #predefinedCommentsChart [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountComments">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListComments [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
            </div>
          </div>
        </div>

        <!---- Observe ---->
        <div class="mt-2 col-12 p-0" #overallComplianceDetails [ngClass]="!isObserve ? 'hideObserve' : ''" *ngIf="!overallComplianceNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{'EVALUATION.OVERALL_COMPLIANCE' | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="overallComplianceFilter">

                    <span>{{ overallComplianceFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ overallComplianceFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #overallCompliance [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountOverallCompliance">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListOverallCompliance *ngIf="childChart.categories.length > 0"
                  [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 col-12 p-0" #fiveMomentsDetails [ngClass]="!isObserve ? 'hideObserve' : ''" *ngIf="!fiveMomentsNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{ translationKeys.Dashboard.FiveMoments | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="fiveMomentsFilter">
                    <span>{{ fiveMomentsFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ fiveMomentsFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #fiveMoments [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div *ngFor="let childChart of childChartCountFiveMoments">
                <div class="chart mt-2" *ngIf="childChart.categories.length > 0">
                  <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListFiveMoments [type]="'bar'"
                    [maxDivisions]='10' [maxBar]='10'>
                  </lib-ph-bhp-bar-chart>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 col-12 p-0" #asepticProceduresDetails [ngClass]="!isObserve ? 'hideObserve' : ''" *ngIf="!asepticProceduresNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{'EVALUATION.STATISTICS_ASEPT' | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="asepticProceduresFilter">

                    <span>{{ asepticProceduresFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ asepticProceduresFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #asepticProcedures [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountAsepticProcedures">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListAsepticProcedures *ngIf="childChart.categories.length > 0" [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 col-12 p-0" #observeCommentsDetails [ngClass]="!isObserve ? 'hideObserve' : ''" *ngIf="!observeCommentsNoDataFound">
          <div class="col-12 static-card">
            <div class="row justify-content-between align-items-center">
              <div #filterDetails>
                <div class="col-auto">
                  <h1 class="section-title">{{'EVALUATION.OBSERVE_COMMENTS' | translate }}</h1>
                  <div class="staticCardUlList" *ngIf="observeCommentsFilter">

                    <span>{{ observeCommentsFilter?.filter[0]?.startDate | date:'dd/MM/yyyy'}}
                      -
                      {{ observeCommentsFilter?.filter[0]?.endDate | date:'dd/MM/yyyy' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="chart mt-2" *ngIf="printChart">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #observeComments [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
              <div class="chart mt-2" *ngFor="let childChart of childChartCountObserveComments">
                <lib-ph-bhp-bar-chart [isExportReport]="true" #chartListObserveComments *ngIf="childChart.categories.length > 0" [type]="'bar'" [maxDivisions]='10' [maxBar]='10'>
                </lib-ph-bhp-bar-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </kendo-pdf-export>
</div>
